"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTypeIcon = exports.StyledShareIcons = exports.StyledItemList = exports.StyledItemCardTitle = exports.StyledItemCard = exports.CardContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ArcgisItemCard = _interopRequireDefault(require("calcite-react/ArcgisItemCard"));
var _Tooltip = _interopRequireDefault(require("calcite-react/Tooltip"));
var _CheckboxStyled = require("calcite-react/Checkbox/Checkbox-styled");
var _ArcgisItemCardStyled = require("calcite-react/ArcgisItemCard/ArcgisItemCard-styled");
var _ButtonStyled = require("calcite-react/Button/Button-styled");
var _ElementsStyled = require("calcite-react/Elements/Elements-styled");
var _Elements = require("calcite-react/Elements");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin: auto auto auto 0;\n"]);
  _templateObject6 = function _templateObject6() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  margin-top: auto;\n  background-color: ", ";\n  border-radius: 18px;\n  padding: 5px 1px 0px 1px;\n"]);
  _templateObject5 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _taggedTemplateLiteral([""]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  box-shadow: 0 0 0 1px ", ",\n    0 0 16px 0 rgb(0 0 0 / 0%);\n  grid-template-columns: 25% 1fr;\n\n  ", " {\n    margin-top: auto;\n    overflow: hidden;\n  }\n\n  ", " {\n    align-items: flex-start;\n    flex-direction: row;\n    overflow: hidden;\n  }\n\n  ", " > span {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  ", " {\n    margin-left: 0px;\n  }\n\n  [class=\"calcite-icon\"] {\n    padding: 0px 5px 0px 5px;\n  }\n\n  ", " {\n    margin-left: 0px;\n  }\n\n  ", " {\n    background-size: contain, 33% !important;\n    background-color: ", " !important;\n    background-position: center top, center top !important;\n    border: 0.5rem solid ", ";\n    min-width: 80px;\n  }\n\n  :hover {\n    box-shadow: 0 0 0 1px ", ",\n      0 0 16px 0 rgb(0 0 0 / 8%);\n  }\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n\n  ", " {\n    position: absolute;\n    z-index: 3;\n    margin-right: auto;\n    padding: 0.5rem 0.5rem 0.25rem 0.5rem;\n  }\n\n  ", " {\n    background-color: rgba(255, 255, 255, 0.85);\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 2px;\n    width: 22px;\n    height: 22px;\n  }\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr;\n  row-gap: 1.5rem;\n  grid-auto-rows: 1fr;\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledItemList = _styledComponents.default.div(_templateObject());
exports.StyledItemList = StyledItemList;
var CardContainer = _styledComponents.default.div(_templateObject2(), _CheckboxStyled.StyledCheckboxGroup, _CheckboxStyled.StyledDisplayCheckbox);
exports.CardContainer = CardContainer;
var StyledItemCard = (0, _styledComponents.default)(_ArcgisItemCard.default)(_templateObject3(), function (props) {
  return props.theme.palette.lighterGray;
}, _ArcgisItemCardStyled.StyledActionsContainer, _ArcgisItemCardStyled.StyledCardItemMetrics, _ArcgisItemCardStyled.StyledCardItemText, _ArcgisItemCardStyled.StyledCardItemIconLabelText, _ButtonStyled.StyledButton, _ElementsStyled.CalciteFigure, function (props) {
  return props.theme.palette.lightestGray;
}, function (props) {
  return props.theme.palette.lightestGray;
}, function (props) {
  return props.theme.palette.lighterGray;
});
exports.StyledItemCard = StyledItemCard;
var StyledItemCardTitle = (0, _styledComponents.default)(_Elements.CalciteA)(_templateObject4());
exports.StyledItemCardTitle = StyledItemCardTitle;
var StyledShareIcons = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.theme.palette.lightestGray;
});
exports.StyledShareIcons = StyledShareIcons;
var StyledTypeIcon = (0, _styledComponents.default)(_Tooltip.default)(_templateObject6());
exports.StyledTypeIcon = StyledTypeIcon;